import React from "react";
import { Outlet } from "react-router-dom";
import PublicHeader from "@/components/layout/PublicHeader";
import PublicFooter from "@/components/layout/PublicFooter";
import ErrorBoundary from "@/components/ErrorBoundary";
import { MobileActionBar } from "@/components/layout/MobileActionBar";
import { CartDrawer } from "@/components/CartDrawer";
import { RecognitionBanner } from "@/components/RecognitionBanner";

export default function PublicLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-ei-white">
      <PublicHeader />
      <RecognitionBanner />
      <main className="flex-1">
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      </main>
      <PublicFooter />
      <div className="md:hidden h-[68px] bg-ei-navy" aria-hidden="true" />
      <MobileActionBar />
      <CartDrawer />
    </div>
  );
}
